import styled from 'styled-components/macro';

export const SelectHolder = styled.div`
  width: 100%;
  margin-top: 5px;

  .Select-input {
    display: none !important;
  }
  .Select-menu {
    text-align: left;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: red;
    border-width: 0 !important;
    border: 0 !important;
  }
  .Select-value,
  .Select-placeholder,
  .Select-control,
  .Select-option,
  .Select-noresults {
    text-align: left;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: red;
    border-width: 0 !important;

    :hover,
    :focus {
      border-width: 0 !important;
      border-color: red !important;
      box-shadow: none;
      stroke: none;
    }
  }

  .Select-value,
  .Select-placeholder {
    padding-left: 0 !important;
  }

  .Select-menu-outer {
    border-color: #c7ccdb !important;
  }
`;
